<div class="search-results">
  <div class="results-inner">
    <ng-container *ngIf="books.length; else maybeNoResults">
      <mat-card *ngFor="let book of books; let i = index"
                class="book-card"
                [class.expanded]="isCardExpanded(book.md5)">
        <img
          class="cover"
          [src]="getCoverUrl(book)"
          (error)="onCoverError(book, $event)"
          [alt]="book.title + ' cover'"
        />

        <div class="info">
          <mat-card-header>
            <mat-card-title>{{ book.title }}</mat-card-title>
            <mat-card-subtitle>{{ book.authors.join(', ') }}</mat-card-subtitle>
          </mat-card-header>

          <mat-card-content>
            Format: {{ book.format }} &nbsp;|&nbsp; Size: {{ book.fileSize }}

            <!-- Book Description -->
            <div class="book-description" *ngIf="book.description">
              <button
                mat-icon-button
                class="expand-toggle"
                (click)="toggleCardExpansion(book.md5)"
                [disabled]="!needsExpansion(book.description)"
                [attr.aria-label]="isCardExpanded(book.md5) ? 'Collapse' : 'Expand'">
                <mat-icon>{{ isCardExpanded(book.md5) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
              </button>
              <p class="description-text" [class.expanded]="isCardExpanded(book.md5)">
                {{ book.description }}
                <mat-icon
                  *ngIf="book.descriptionSource === 'gpt'"
                  class="description-source-icon robot-icon"
                  aria-label="AI-generated description"
                  matTooltip="AI-generated description">
                  smart_toy
                </mat-icon>
                <mat-icon
                  *ngIf="book.descriptionSource === 'googlebooks'"
                  class="description-source-icon book-icon"
                  aria-label="Google Books description"
                  matTooltip="From Google Books">
                  menu_book
                </mat-icon>
                <mat-icon
                  *ngIf="book.descriptionSource === 'openlibrary'"
                  class="description-source-icon leaf-icon"
                  aria-label="OpenLibrary description"
                  matTooltip="From OpenLibrary">
                  eco
                </mat-icon>
              </p>
            </div>

            <!-- Retrieve Summary Button (for books 11+) -->
            <div class="book-description retrieve-summary-container" *ngIf="!book.description && i >= 10">
              <button
                mat-raised-button
                color="accent"
                class="retrieve-summary-btn"
                (click)="onFetchDescription(book)">
                Retrieve Summary
              </button>
            </div>
          </mat-card-content>

          <!-- ACTION BUTTONS -->
          <mat-card-actions class="action-buttons">
            <!-- library -->
            <button mat-raised-button color="primary" (click)="onSendToLibrary(book)">
              <ng-container [ngSwitch]="book.libraryState">
                <span *ngSwitchCase="'sending'">Saving…</span>
                <span *ngSwitchCase="'success'">✓ Saved</span>
                <span *ngSwitchCase="'error'">✖ Retry</span>
                <span *ngSwitchDefault class="button-label-with-icon">
                  <mat-icon class="inline-icon">menu_book</mat-icon>
                  Library
                </span>
              </ng-container>
            </button>

            <button
              mat-raised-button
              color="accent"
              (click)="onSendToDropbox(book)"
              [disabled]="book.sendState === 'sending'"
            >
              <ng-container [ngSwitch]="book.sendState">
                <span *ngSwitchCase="'sending'">Uploading…</span>
                <span *ngSwitchCase="'success'">✓ Uploaded!</span>
                <span *ngSwitchCase="'error'">✖ Retry</span>
                <span *ngSwitchDefault>📤 Dropbox</span>
              </ng-container>
            </button>

            <button
              mat-raised-button
              color="primary"
              (click)="onSendToDadsKindle(book)"
              [disabled]="book.dadsKindleState === 'sending' || book.format !== 'EPUB'"
            >
              <ng-container [ngSwitch]="book.dadsKindleState">
                <span *ngSwitchCase="'sending'">Sending…</span>
                <span *ngSwitchCase="'success'">✔ Sent!</span>
                <span *ngSwitchCase="'error'">✖ Retry</span>
                <span *ngSwitchDefault>Dad's Kindle</span>
              </ng-container>
            </button>

            <button
              mat-raised-button
              color="primary"
              (click)="onSendToMomsKindle(book)"
              [disabled]="book.momsKindleState === 'sending' || book.format !== 'EPUB'"
            >
              <ng-container [ngSwitch]="book.momsKindleState">
                <span *ngSwitchCase="'sending'">Sending…</span>
                <span *ngSwitchCase="'success'">✔ Sent!</span>
                <span *ngSwitchCase="'error'">✖ Retry</span>
                <span *ngSwitchDefault>Mom's Kindle</span>
              </ng-container>
            </button>
          </mat-card-actions>
        </div>
      </mat-card>
    </ng-container>

    <ng-template #maybeNoResults>
      <p *ngIf="searchPerformed && !loading">No results</p>
    </ng-template>
  </div>
</div>
